import { CalendarClock, Gauge, KanbanSquare, Shield, type LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import type { SidebarNavigationType } from '@eo/shared';

import type { RootState } from './store';

function icon(Glyph: LucideIcon): ReactNode {
  return <Glyph className="h-5 w-5" />;
}

// Factory form so the item set reacts to the staff slice: the Admin entry is
// visible only to staff admins. Settings is deliberately absent — it is reached
// through the sidebar-footer account menu.
export function sidebarNavigation(state: unknown, _pathname: string): SidebarNavigationType {
  const me = (state as RootState).staff.me;

  const items = [
    { label: 'Review Board', path: '/', icon: icon(KanbanSquare), end: true },
    { label: 'Time Tracking', path: '/time-tracking', icon: icon(CalendarClock) },
    { label: 'Capacity', path: '/capacity', icon: icon(Gauge) },
    ...(me?.isAdmin ? [{ label: 'Admin', path: '/admin', icon: icon(Shield) }] : []),
  ];

  return [{ title: 'Mission Control', items }];
}
